module.exports = __webpack_public_path__ + "static/media/roo_wor_a_lad.992111b4.png";